import React, { useContext, useState, useEffect } from "react";
import "./BudgetMain.css";
import { BudgetReport } from "./BudgetComponents/BudgetReport";
import transactionIcon from "../../assets/images/budget/transactionIcon.png";
import { useHistory } from "react-router-dom";
import DEATH_API from "../../apis/death.api";
import Loader from "../../components/styled-components/loader/loader";
import { useDispatch, useSelector } from "react-redux";
import { setActiveBudgetTab } from "../../redux/slices/loginSlice";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import { Menu, Dropdown } from "antd";
import editIcon from "../../assets/images/budget/dropdown.png";
import creditCard from "../../assets/images/creditcard.png";
import loanImg from "../../assets/images/n.png";
import savingImg from "../../assets/images/bank.png";
import uncategorizedImg from "../../assets/images/adjustable_dollar2.png";
import investmentImg from "../../assets/images/stock.png";
import {
  setRefreshTime,
  setRefreshTimeAsset,
} from "../../redux/slices/itemsSlice";
import { MODULE_API } from "../../apis";
import { ProgressContext } from "../../utils/ProgressContext";
import swal from "sweetalert";
import moment from "moment";
import ModalVideo from "../ModuleVideos/ModalVideo";

export const BudgetMain = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState(null);
  const [budgetData, setBudgetData] = useState(null);
  const [syncPayload, setSyncPayload] = useState([]);
  const [clientBanks, setClientBanks] = useState(null);
  const { startLoading, stopLoading, loadingProgress } =
    useContext(ProgressContext);
  const refreshTime = useSelector(
    (state) => state.rootReducer.itemsInfo.refreshTimeAsset
  );
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const financialAccess =
    localStorage.getItem("financialAccess") != "undefined" &&
    JSON.parse(localStorage.getItem("financialAccess") || null);
  const getUserTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBankAccountDetails();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getBudgetData = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBudgetDataAll();
      if (data && data.status === 200 && data.data) {
        // setBudgetData(data.categorized);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getCalculatedBudget = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getCalculatedBudget();
      if (data && data.status === 200 && data.categoryBudgets) {
        console.log("data", data.categoryBudgets);
        const usedAmounts = data.categoryBudgets.map(
          (item) => item.value.usedAmount
        );
        const categoryName = data.categoryBudgets.map(
          (item) => item.value.categoryName
        );
        const amountsSums = data.categoryBudgets.reduce((accumulator, item) => {
          accumulator.push(item.value.usedAmount + item.value.leftAmount);
          return accumulator;
        }, []);
        console.log("categorires", usedAmounts, categoryName, amountsSums);
        const resultObject = {
          usedAmounts,
          categoryName,
          amountsSums,
        };
        setBudgetData(resultObject);
        // setCategoryBudget(data.categoryBudgets);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBudgetTransaction();
      if (data && data.data) {
        const allAccount = data.data.map((item) => {
          // If amount is negative, convert it to positive
          if (item.amount && item.typeOfTransaction === null) {
            item.amount = -1 * item.amount;
          }
          return item;
        });
        const checkingSavingData = allAccount.filter((item) => {
          return (
            (item.accountType === "checking" ||
              item.accountType === "savings") &&
            item.categoryFromPlaid !== null
          );
        });
        const creditData = allAccount.filter((item) => {
          return (
            item.accountType === "credit card" &&
            item.categoryFromPlaid !== null
          );
        });
        const investmentData = allAccount.filter((item) => {
          return (
            item.accountType !== "checking" &&
            item.accountType !== "savings" &&
            item.accountType !== "credit card" &&
            item.accountType !== "student" &&
            item.accountType !== "loan" &&
            item.accountType !== "auto" &&
            item.accountType !== "business" &&
            item.accountType !== "commercial" &&
            item.accountType !== "construction" &&
            item.accountType !== "consumer" &&
            item.accountType !== "overdraft" &&
            item.accountType !== "home equity" &&
            item.accountType !== "line of credit" &&
            item.accountType !== "mortgage" &&
            item.categoryFromPlaid !== null
          );
        });
        const studentData = allAccount.filter((item) => {
          return (
            (item.accountType === "student" ||
              item.accountType === "mortgage" ||
              item.accountType === "loan" ||
              item.accountType === "auto" ||
              item.accountType === "business" ||
              item.accountType === "commercial" ||
              item.accountType === "construction" ||
              item.accountType === "consumer" ||
              item.accountType === "overdraft" ||
              item.accountType === "home equity" ||
              item.accountType === "line of credit") &&
            item.categoryFromPlaid !== null
          );
        });
        const cashData = allAccount.filter((item) => {
          return item.paidUsing === "Cash" && item.categoryFromPlaid !== null;
        });
        const nullCategoryDataNullCategory = allAccount.filter((item) => {
          return item.categoryFromPlaid === null;
        });

        const resultObject = {
          allAccount,
          checkingSavingData,
          creditData,
          investmentData,
          studentData,
          nullCategoryDataNullCategory,
          cashData,
        };
        setTransactions(resultObject);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllResults();
  }, []);

  const getAllResults = async () => {
    // await getCalculatedBudget();
    // await getUserTransactions();
    await getBankDetails();
    await getTransactions();
  };
  const refreshAssetModule = async () => {
    try {
      setLoading(true);
      const response = await MODULE_API.refreshAssetModule();
      if (
        response &&
        response.status === 200 &&
        response.updatedAt &&
        response.updatedAt
      ) {
        dispatch(setRefreshTimeAsset(response.updatedAt));
      }
      // console.log("response",response)
      // if(response && response.status===429){
      //   swal("Oops!",response.message,"error");
      // }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  const refreshLiabilityModule = async () => {
    try {
      setLoading(true);
      const response = await DEATH_API.refreshLiability();
      console.log("response refresf", response.data);
      if (
        response &&
        response.status === 200 &&
        response.updatedAt &&
        response.updatedAt.updatedAt
      ) {
        dispatch(setRefreshTime(response.updatedAt.updatedAt));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  const refreshDataPlaid = async () => {
    try {
      // setLoading(true);
      const interval = startLoading();

      const refreshData = await DEATH_API.refreshBanksData(
        syncPayload && { accounts: syncPayload }
      );
      if (refreshData && refreshData.status === 200) {
        await refreshLiabilityModule();
        await refreshAssetModule();
      }
      if (refreshData && refreshData.status === "ERROR") {
        swal("Oops!", refreshData.message, "error");
      }
      clearInterval(interval);
      stopLoading();
      // setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
      stopLoading(0);
    }
  };
  const getBankDetails = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBankDetails();
      setSyncPayload([]);
      let obj = [];
      let bankData = {};
      if (data && data.data) {
        const newArray = data.data.map((account) => {
          return {
            accountId: account.accountId,
            accountName: `${account.accountName}`,
            bankName: account.bankName,
            subType: account.subType,
            accountNumber: account.mask,
            accountTitle: `${account.accountName} ${account.mask}`,
            balance: account.balance,
          };
        });
        setClientBanks([
          ...newArray,
          {
            accountId: 1234,
            accountName: "cash",
            bankName: "devbank",
            subType: "debsubtype",
            accountNumber: 1122,
            accountTitle: "Cash",
            balance: 1111,
          },
        ]);

        data.data.forEach((item) => {
          if (!bankData[item.bankName]) {
            bankData[item.bankName] = [];
          }
          bankData[item.bankName].push({
            ...item,
            bankName: item.bankName,
            mask: item.mask,
          });
        });
        data.data.map((item, idx) => {
          obj.push({
            bankName: item.bankName,
            mask: item.mask,
            accessToken: item.accessToken,
          });
        });
      }
      setSyncPayload((prevState) => [...prevState, ...obj]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const syncAllPlaid = async () => {
    await refreshDataPlaid();
    // await refreshLiabilityModule();
    // await refreshAssetModule();
  };
  console.log("financialAccess",financialAccess)
  return (
    <div className="BudgetMain">
    <ModalVideo module="Budget" autoOpen={true} />
      <div className="budgetcreate" style={{ justifyContent: "space-between" }}>
        <div className="addbudgetSection">
          <div className="addTitle">
            Dashboard
            <span style={{ marginLeft: "10px" }}>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget");
                        }}
                      >
                        Dashboard
                      </div>
                    </Menu.Item>
                    {(!financialAccess || !financialAccess.hideTransactions) && (
                      <Menu.Item>
                        <div
                          onClick={() => {
                            history.push("/budget/add/transaction");
                          }}
                        >
                          Transactions
                        </div>
                      </Menu.Item>
                    )}
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/budget");
                        }}
                      >
                        Budget
                      </div>
                    </Menu.Item>
                    {(!financialAccess || !financialAccess.hideTransactions) && (
                      <Menu.Item
                      // style={{ cursor: "not-allowed", opacity: "0.7" }}
                      >
                        <div
                          onClick={() => {
                            history.push("/budget/transaction/recurring");
                          }}
                        >
                          Recurring
                        </div>
                      </Menu.Item>
                    )}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={editIcon} height={12} width={18} alt="icon"></img>
                </a>
              </Dropdown>
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "black",
            }}
          >
            {refreshTime &&
              `Updated at: ${moment(refreshTime)
                .local()
                .format("MM/DD/YYYY [at] hh:mmA")}`}
          </div>
          {userRole && userRole !== "FreeTrail" || userRole!=="Financial Advisor Client" && (
            <button
              className={
                syncPayload && syncPayload.length === 0
                  ? "addbuttonassets disableButton"
                  : "addbuttonassets"
              }
              disabled={syncPayload && syncPayload.length === 0}
              onClick={() => {
                syncAllPlaid();
              }}
            >
              {" "}
              Refresh
            </button>
          )}
          {userRole && userRole !== "FreeTrail" || userRole!=="Financial Advisor Client" && (
            <button
              className="addbuttonassets"
              onClick={() => {
                history.push("/plaid");
              }}
            >
              {" "}
              + Link Account
            </button>
          )}
          { localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client" && (<button
            className="addbuttonassets"
            onClick={() => {
              history.push("/budget/add/budget");
            }}
          >
            {" "}
            + Add Budget
          </button>)}
        </div>
      </div>
      <div className="BudgetMainReport">
        <BudgetReport
          transactions={transactions && transactions}
          clientBanks={clientBanks && clientBanks}
        />
      </div>
      {/*  <div className="BudgetMainReport" style={{ position: "relative" }}>
        <div className="reportCard3">
          <div
            className="budget-home-icon-container"
            style={{ justifyContent: "space-between" }}
          >
            <div>
              <h3
                className="Reportheading"
                style={{ fontSize: "16px", fontWeight: "600", color: "black" }}
              >
                Accounts
              </h3>
            </div>
            <button
              className="addbuttonassets"
              onClick={() => {
                dispatch(setActiveBudgetTab(0));
                history.push("/budget/add/transaction");
              }}
            >
              {" "}
              See All Transaction
            </button>
          </div>
          <div className="reprotcardRow">
            <div className="listingContainer">
              <React.Fragment>
                {transactions && transactions.length > 0 ? (
                  transactions.map((item, index) => (
                    <div
                      key={index}
                      className="list-row-transaction"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        console.log("item.prioirty", item.prioirty);
                        dispatch(setActiveBudgetTab(item.prioirty));
                        history.push("/budget/add/transaction");
                      }}
                    >
                      <div className="transactionLogo">
                        <img
                          src={item.image}
                          height={"32px"}
                          width={"32px"}
                          alt={"new"}
                        />
                      </div>
                      <div className="listname-dark">
                        <div>{item.bankName}</div>
                        <div style={{ color: "#030229", fontWeight: "400" }}>
                          $
                          {item.total
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="nodata">No Data to Show</div>
                )}
              </React.Fragment>
            </div>
          </div>
        </div>
        <NewLoader isLoading={loading} />
      </div> */}

      {/*<NewLoader isLoading={loading} />*/}
    </div>
  );
};
